import {
  TableBody as TableBodyDS,
  TableCell,
  TableRow,
} from '@cambridgeassessment/cambridge-ui';
import * as React from 'react';
import { memo, useCallback } from 'react';
import { hot } from 'react-hot-loader/root';
import { useHistory } from 'react-router-dom';
import { useTableBodyStyles } from './styles';
import { Row } from './types';

type Props = {
  rows: Row[];
  emptyRows: number;
};

const TableBody: React.FC<Props> = ({ rows, emptyRows }) => {
  const { clickable } = useTableBodyStyles();
  const history = useHistory();
  const handleRedirect = useCallback(
    (event: any, link: string | undefined) => {
      if (
        event.target.matches('a') ||
        event.target.matches('button') ||
        event.target.matches('span')
      ) {
        return;
      }
      if (link) {
        history.push(link);
      }
    },
    [history]
  );
  return (
    <TableBodyDS data-testid="user-table-body">
      {rows.map((row, index) => (
        <TableRow
          hover
          key={`row-${index}`}
          onClick={(event) => handleRedirect(event, row.link)}
          className={row.link ? clickable : null}
        >
          {Object.entries(row.cells).map(([oid, content], idx) => (
            <TableCell key={`${oid}-${idx}`}>{content}</TableCell>
          ))}
        </TableRow>
      ))}
      {emptyRows > 0 && (
        <TableRow style={{ height: 56 * emptyRows }}>
          <TableCell />
        </TableRow>
      )}
    </TableBodyDS>
  );
};

export default hot(memo(TableBody));
